import { useMemo } from 'react';
import { ContestStage } from '@diritto/common/content/types/content-contest-info-types';
import { useGetContestStageQuery } from '@/queries/contests/useGetContestStageQuery';

export const useStageValidationCheck = (contestId: number, stage: ContestStage) => {
  const { data: res } = useGetContestStageQuery(contestId);
  return useMemo(() => res?.contestStage.stage === stage, [res?.contestStage.stage, stage]);
};

export const useContestStage = (contestId: number) => {
  const { data: res } = useGetContestStageQuery(contestId);
  return useMemo(() => res?.contestStage.stage, [res?.contestStage]);
};
